<div *ngFor="let item of getPortfolios()" class="port-body">
    <p *ngIf="item.name"><b>{{item.name}}</b></p>
    <p>{{item.text}}</p>
    
    <div id="carousel-{{item.id}}" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner">
            <div class="carousel-item" *ngFor="let i of item.images; let c = index" [class.active]="c == 0">
                <div class="image-caption">
                    <h5>{{getImageLabel(i)}} &nbsp;</h5>
                </div>
                <img src="/assets/images/Portfolio/{{i}}.jpg" class="d-block w-100" alt="...">
            </div>
        </div>
        <ng-container *ngIf="item.images.length > 1">
            <a class="carousel-control-prev" href="#carousel-{{item.id}}" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carousel-{{item.id}}" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"  style="background-image: linear-gradient(270deg, rgba(0, .25), rgba(0, .001));"></span>
                <span class="sr-only">Next</span>
            </a>
        </ng-container>
    </div>
</div>